module.exports = __webpack_public_path__ + "static/media/iconfinder-icon.614fb420.svg";